const DEFAULT_EMULATOR_UI_URL = 'http://localhost:4001';

const isUsingFirestoreEmulator = () =>
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATORS == '1';

/**
 * Encodes a Firestore document path for Firebase Console deeplinks (~2F for /).
 * @param {string} collection
 * @param {string} documentId
 * @returns {string}
 */
const encodeConsoleDocumentPath = (collection, documentId) =>
  `~2F${[collection, documentId].join('~2F')}`;

/**
 * Returns a URL to view a Firestore document in the Emulator Suite UI (local dev)
 * or Firebase Console (deployed dev/prod).
 * @param {string} collection
 * @param {string} documentId
 * @returns {string}
 */
export function getFirestoreDocumentUrl(collection, documentId) {
  if (isUsingFirestoreEmulator()) {
    const base = process.env.REACT_APP_FIREBASE_EMULATOR_UI_URL || DEFAULT_EMULATOR_UI_URL;
    return `${base}/firestore/default/data/${collection}/${documentId}`;
  }

  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const encodedPath = encodeConsoleDocumentPath(collection, documentId);

  return `https://console.firebase.google.com/project/${projectId}/firestore/data/${encodedPath}`;
}
